const text = (value) => String(value || '').trim()

const normalizeImageUrl = (value) => {
  const image = text(value)
  if (!image) return ''
  if (/^(https?:|data:|blob:)/i.test(image)) return image
  if (image.startsWith('//')) return `https:${image}`
  if (image.startsWith('/')) return `https://app.atharo.app${image}`
  if (image.toLowerCase().startsWith('images/')) return `https://app.atharo.app/${image}`
  return `https://app.atharo.app/images/${image}`
}

export const getTeacherImageUrl = (teacher) => normalizeImageUrl(
  teacher?.imageUrl
  || teacher?.imageURL
  || teacher?.ImageUrl
  || teacher?.ImageURL
  || teacher?.ImageName
  || teacher?.imageName
  || teacher?.Image
  || teacher?.image
  || teacher?.Photo
  || teacher?.photo
)

